const delay = <T = undefined>(timeout: number, value?: T) =>
  new Promise<T>((resolve) => {
    window.setTimeout(() => resolve(value), timeout)
  })

export default delay
